import { API_BASE_URL } from './api';

/**
 * Horizons the user may manage in settings (ingestion / views): same basis as SuffixSelector
 * — cascade_user_suffixes + owned — except admin/superadmin, who get all visibility-filtered instances.
 *
 * @param {typeof import('./api').getAuthHeaders} getAuthHeaders
 * @param {{ accountType?: string } | null | undefined} user
 * @returns {Promise<{ horizons: any[], error: string | null }>}
 */
export async function fetchHorizonsForSettings(getAuthHeaders, user) {
  const headers = await getAuthHeaders();
  const isAdmin = user?.accountType === 'admin' || user?.accountType === 'superadmin';

  try {
    if (isAdmin) {
      const horizonResp = await fetch(`${API_BASE_URL}/casc/v1/api/instances`, {
        method: 'POST',
        headers,
        body: JSON.stringify({})
      });
      const horizonData = await horizonResp.json();
      if (!horizonData.success || !Array.isArray(horizonData.instances)) {
        return { horizons: [], error: horizonData.message || horizonData.error || 'Failed to load horizons' };
      }
      if (horizonData.instances.length === 0) {
        return { horizons: [], error: null };
      }
      return { horizons: horizonData.instances, error: null };
    }

    const horizonResp = await fetch(`${API_BASE_URL}/casc/v1/api/instances/user-suffixes`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...headers
      },
      body: JSON.stringify({})
    });
    const horizonData = await horizonResp.json();
    if (!horizonResp.ok || !horizonData.success) {
      return {
        horizons: [],
        error: horizonData.message || horizonData.error || 'Failed to load your horizons'
      };
    }
    const suffixes = horizonData.suffixes || [];
    return { horizons: suffixes, error: null };
  } catch (e) {
    return { horizons: [], error: e?.message || 'Failed to load horizons' };
  }
}
